import axios from 'axios';

const URL_API_CLIENTE_DIRECCION = process.env.VUE_APP_URL_API_CLIENTE_DIRECCION;


export class ClienteDireccionesApiService {

  getDireccionesByCliente(clienteUid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_CLIENTE_DIRECCION}getDireccionesByCliente/${clienteUid}/`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  guardarDireccionCliente(direccion) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_CLIENTE_DIRECCION}guardarDireccionCliente`;
    return axios
      .post(url, direccion, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  borrarDireccionCliente(direccionId) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_CLIENTE_DIRECCION}borrarDireccionCliente/${direccionId}/`;
    return axios
      .delete(url, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  updateDireccionCliente(direccion) {
    const url = `${URL_API_CLIENTE_DIRECCION}updateDireccionCliente`;
    var options = {
      headers: {
        'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")
      }
    };
    return axios
      .put(url, direccion, options)
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}